import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 노토 산스 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" open modal ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 스포카 산스 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" be empty ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" change pad height ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" toggle pad ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" toggle width ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" add line max width ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" toggle line Color ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" open browser ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" send message ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_toggle_icon = _resolveComponent("ag-toggle-icon")!
  const _component_ag_signature_pad = _resolveComponent("ag-signature-pad")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_modal = _resolveComponent("ag-modal")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            "font-weight": "900",
            "font-size": "50px"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = true))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalPageName = 'bar'))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_ag_img, { src: "https://via.placeholder.com/150" }),
          _createVNode(_component_ag_toggle_icon),
          (_ctx.padToggle)
            ? (_openBlock(), _createBlock(_component_ag_signature_pad, {
                key: 0,
                empty: _ctx.isEmpty,
                "onUpdate:empty": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isEmpty) = $event)),
                height: _ctx.padHeight,
                width: _ctx.padToggleWidth,
                bg: "blue",
                "line-max-width": _ctx.lineMaxWidth,
                "line-color": _ctx.lineColor
              }, null, 8, ["empty", "height", "width", "line-max-width", "line-color"]))
            : _createCommentVNode("", true),
          _createVNode(_component_ag_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isEmpty), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEmpty = true))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.padHeight += 50))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.padToggle = !_ctx.padToggle))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleWidth()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.lineMaxWidth += 2))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleLineColor()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openBrowser()))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_ag_button, { onClick: _ctx.onMessage }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ag_text, null, {
            default: _withCtx(() => [
              _createTextVNode("isWebKit" + _toDisplayString(_ctx.isWebKit), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.messageRef), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ag_modal, {
            modelValue: _ctx.isOpen,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isOpen) = $event)),
            height: "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_box, {
                height: _ctx.height,
                transition: "height 0.7s",
                position: "relative",
                dp: "flex",
                direction: "column"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modalPage.component), { onGo: _ctx.go }, null, 8, ["onGo"]))
                ]),
                _: 1
              }, 8, ["height"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}